var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-checkbox',{staticClass:"ml-3",on:{"change":_vm.handleMarkChange},model:{value:(_vm.mark),callback:function ($$v) {_vm.mark=$$v},expression:"mark"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }